import {
    CREATEBUSINESSNATUREMAPPING_SUCCESS,
    CREATEBUSINESSNATUREMAPPING_FAILED,
    RESET_CREATEBUSINESSNATUREMAPPING,
    LOADING_CREATEBUSINESSNATUREMAPPING,
    NETWORK_ERROR_CREATEBUSINESSNATUREMAPPING,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_CREATEBUSINESSNATUREMAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case CREATEBUSINESSNATUREMAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case CREATEBUSINESSNATUREMAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_CREATEBUSINESSNATUREMAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_CREATEBUSINESSNATUREMAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
